import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {DashboardService} from '../dashboard.service';
import {AngularEditorConfig} from '@kolkov/angular-editor';
import {Location} from '@angular/common';

@Component({
    selector: 'app-edit-rating-category',
    templateUrl: './edit-rating-category.component.html',
    styleUrls: ['./edit-rating-category.component.css'],
    standalone: false
})
export class EditRatingCategoryComponent implements OnInit {
  isCategoryCreated = false;
  categoryId = '';
  rateCategory: any = {
    category: [],
    parameters: [
      {
        category: '',
        ratingCategory: '',
        fieldName: '',
        icon: ''
      },
      {
        category: '',
        ratingCategory: '',
        fieldName: '',
        icon: ''
      },
      {
        category: '',
        ratingCategory: '',
        fieldName: '',
        icon: ''
      }]
  };
  categories: any[] = [];
  editorConfig: AngularEditorConfig = {
    editable: true,
    height: 'auto',
    minHeight: '10rem',
    minWidth: '70rem',
    enableToolbar: true,
    showToolbar: true,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['undo',
        'redo', 'strikeThrough',
        'subscript',
        'superscript', 'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
      ],
      ['fontSize', 'customClasses',
        'removeFormat',
        'textColor',
        'backgroundColor',
        'unlink',
        'insertVideo']
    ]
  };

  constructor(private api: DashboardService,
              private route: ActivatedRoute,
              private toastr: ToastrService,
              private _location: Location) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.categoryId = params.id);
    this.getAllCategories();
    // this.getSingleCategory();
  }

  getAllCategories(): void {
    this.api.getAllCategories('').subscribe((data) => {
      this.categories = data.categories;
      this.getSingleRatingCategory();
      // this.getSingleCategory(this.categories[0].id);
    }, err => this.toastr.error(err.error.message));
  }

  getSingleRatingCategory(): void {
    this.api.getRatingCategory(this.categoryId).subscribe((data) => {
      const response = data.response || {};
      this.rateCategory = {
        ...response,
        parameters : !!response.parameters?.length ? response.parameters : this.rateCategory.parameters
      };
    }, err => this.toastr.error(err.error.message));
  }

  updateRatingCategory(): void {
    const payload = {...this.rateCategory};
    if (payload.RatingPositiveNegativeCriteriaType !== 'bhakt_index') {
      // @ts-ignore
      payload.RatingPositiveNegativePercent = 0;
    }
    this.api.updateRatingCategory(this.categoryId, payload).subscribe((data) => {
      this.toastr.success('Updated Successfully', 'Success');
      this._location.back();
    }, (err) => {
      this.toastr.error(err?.error?.message || 'Unable to update rating category');
    });
  }

  isCategoryChecked(id): boolean {
    if (!this.rateCategory.category?.length) {
      return false;
    } else {
      return !!this.rateCategory.category?.find(category => id === category);
    }
  }

  pickIcon(event, index): void {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.api.uploadImage({file: reader.result}).subscribe(res => {
        this.rateCategory.parameters[index].icon = res.response.url;
      });
    };
  }

  uploadImage(event): void {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.api.uploadImage({file: reader.result}).subscribe(res => {
        this.rateCategory.icon = res.response.url;
      });
    };
  }

  catChange(e, id): void {
    if (e.target.checked) {
      this.rateCategory.category.push(id);
    } else {
      const index = this.rateCategory.category.indexOf(id);
      if (index >= 0) {
        this.rateCategory.category.splice(index, 1);
      }
    }
  }
}
